<template>
    <nuxt-link
        :to="localePath(`/works/${id}`)"
        :class="{ hidden: hidden, 'inline-flex md:inline-block': !hidden }"
        class="relative flex-col gap-y-6 md:gap-y-0 max-h-[650px] cursor-pointer w-full group"
        @mouseenter="enterElement($event)"
        @mouseleave="leaveElement($event)"
    >
        <div
            class="left-0 z-20 order-2 inline-block md:order-1 md:absolute bottom-16 text-primary"
        >
            <h2
                ref="text"
                class="transition-colors duration-300 text-6xl uppercase break-words group-hover:text-hoverDark sm:text-7xl md:text-9xl font-display no-ligature !leading-[3.5rem] md:!leading-[6.5rem]"
            >
                {{ title }}
            </h2>
            <h3
                ref="categories"
                class="ml-1 text-xl uppercase transition-colors duration-300 group-hover:text-hoverDark"
            >
                {{ categoriesText }}
            </h3>
        </div>
        <div
            class="order-1 md:order-2 overflow-hidden relative w-full h-[350px] xs:h-[345px] md:h-[650px] z-10 flex justify-end"
        >
            <div
                class="overflow-hidden inline-block h-full relative w-full md:w-[92%]"
            >
                <div
                    data-scroll-class="FADE_UP_IMAGE"
                    class="sm:absolute w-full h-full xl:h-100% 2xl:h-[135%] -top-36"
                >
                    <img
                        :src="image"
                        class="absolute object-cover w-full h-full bg-gray-600 brightness-75"
                    />
                </div>
            </div>
        </div>
    </nuxt-link>
</template>

<script setup lang="ts">
const localePath = useLocalePath();

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    image: {
        type: String,
        required: false,
        default: '',
    },
    categories: {
        type: Array,
        required: false,
        default() {
            return [];
        },
    },
    hidden: {
        type: Boolean,
        required: true,
    },
});

// Computed
const title = computed(() => {
    return props.name.replaceAll('-', ' ');
});
const categoriesText = computed(() => {
    return props.categories.join(', ');
});

// Methods
const enterElement = (e: Event) => {
    // this.animate(1.05, 800, e);
    // Animate Text
    // this.animateTextOnHover([0, -35]);
};
const leaveElement = (e: Event) => {
    // this.animate(1.0, 600, e);
    // Animate Text
    // this.animateTextOnHover([0, 35]);
};
// const isElementInViewport = (element: HTMLElement) => {
//     const rect = element.getBoundingClientRect();
//     return (
//         rect.top >= 0 &&
//         rect.left >= 0 &&
//         rect.bottom <=
//             (window.innerHeight || document.documentElement.clientHeight) &&
//         rect.right <=
//             (window.innerWidth || document.documentElement.clientWidth)
//     );
// };

// const animateTextOnHover = (position: Array<number>) => {
//     const textElement = this.$refs.text as HTMLElement;

//     const letters: any = this.$letterize({
//         targets: textElement,
//         className: "inline-block",
//     });

//     const targets = letters.listAll;

//     // this.anime.remove(targets);
//     this.anime({
//         targets,
//         easing: "easeInOutQuad",
//         duration: 750,
//         translateY: position,
//         delay(_el: any, i: number) {
//             return i * 35;
//         },
//     });
// };
// const animateText = () => {
//     const textElement = this.$refs.text as HTMLElement;
//     const categories = this.$refs.categories as HTMLElement;

//     let targets: any = textElement;

//     if (window.innerWidth > 450) {
//         const letters: any = this.$letterize({
//             targets: textElement,
//             className: "inline-block",
//         });

//         targets = letters.listAll;

//         letters.listAll.push(categories);
//     } else {
//         targets = [targets, categories];
//     }

//     if (!this.isElementInViewport(textElement)) return;

//     this.anime({
//         targets,
//         easing: "easeInOutQuad",
//         duration: 1250,
//         translateY: [65, 0],
//         opacity: [0, 1],
//         delay(_el: any, i: number) {
//             return i * 35;
//         },
//     });
// };
// const animate = (scale: number, duration: number, event: Event) => {
//     const anime: any = (this as any).$anime;
//     const t = event.target as HTMLElement;

//     const image = t.childNodes[2].childNodes[0].childNodes[0];

//     // Animate Image
//     anime.remove(image);
//     anime({
//         targets: image,
//         scale,
//         duration,
//         easing: "easeInOutSine",
//     });
// };

// export default defineNuxtComponent({
//     name: "ProjectFeaturedWidget",
//     props: {
//         id: {
//             type: String,
//             required: true,
//         },
//         name: {
//             type: String,
//             required: true,
//         },
//         image: {
//             type: String,
//             required: false,
//             default: "",
//         },
//         categories: {
//             type: Array,
//             required: false,
//             default() {
//                 return [];
//             },
//         },
//         hidden: {
//             type: Boolean,
//             required: true,
//         },
//     },
//     data() {
//         return {
//             anime: {} as any,
//             textAnimation: {} as any,
//             // isEven: false,
//             // animationTarget: '' as any,
//         };
//     },
//     computed: {
//         title() {
//             return this.name.replaceAll("-", " ");
//         },
//     },
//     mounted() {
//         // this.isEven = this.isEvenFunc(this.index + 1);
//         this.anime = (this as any).$anime;

//         this.animateText();
//     },
//     methods: {
//         enterElement(e: Event) {
//             this.animate(1.05, 800, e);
//             // Animate Text
//             this.animateTextOnHover([0, -35]);
//         },
//         leaveElement(e: Event) {
//             this.animate(1.0, 600, e);
//             // Animate Text
//             this.animateTextOnHover([0, 35]);
//         },
//         animateTextOnHover(position: Array<number>) {
//             const textElement = this.$refs.text as HTMLElement;

//             const letters: any = this.$letterize({
//                 targets: textElement,
//                 className: "inline-block",
//             });

//             const targets = letters.listAll;

//             // this.anime.remove(targets);
//             this.anime({
//                 targets,
//                 easing: "easeInOutQuad",
//                 duration: 750,
//                 translateY: position,
//                 delay(_el: any, i: number) {
//                     return i * 35;
//                 },
//             });
//         },
//         animateText() {
//             const textElement = this.$refs.text as HTMLElement;
//             const categories = this.$refs.categories as HTMLElement;

//             let targets: any = textElement;

//             if (window.innerWidth > 450) {
//                 const letters: any = this.$letterize({
//                     targets: textElement,
//                     className: "inline-block",
//                 });

//                 targets = letters.listAll;

//                 letters.listAll.push(categories);
//             } else {
//                 targets = [targets, categories];
//             }

//             if (!this.isElementInViewport(textElement)) return;

//             this.anime({
//                 targets,
//                 easing: "easeInOutQuad",
//                 duration: 1250,
//                 translateY: [65, 0],
//                 opacity: [0, 1],
//                 delay(_el: any, i: number) {
//                     return i * 35;
//                 },
//             });
//         },
//         animate(scale: number, duration: number, event: Event) {
//             const anime: any = (this as any).$anime;
//             const t = event.target as HTMLElement;

//             const image = t.childNodes[2].childNodes[0].childNodes[0];

//             // Animate Image
//             anime.remove(image);
//             anime({
//                 targets: image,
//                 scale,
//                 duration,
//                 easing: "easeInOutSine",
//             });
//         },
//         isElementInViewport(element: HTMLElement) {
//             const rect = element.getBoundingClientRect();
//             return (
//                 rect.top >= 0 &&
//                 rect.left >= 0 &&
//                 rect.bottom <=
//                     (window.innerHeight ||
//                         document.documentElement.clientHeight) &&
//                 rect.right <=
//                     (window.innerWidth || document.documentElement.clientWidth)
//             );
//         },
//     },
// });
</script>
